/* __next_internal_client_entry_do_not_use__ RevenuePanel auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QuestionSvg from "../assets/question.svg";
import { useColor } from "../hooks/useColor";
import { DrawerMorph } from "./Drawer/DrawerMorph";
import Link from "next/link";
import styles from "./RevenuePanel.module.scss";
import { useStore } from "../StoreProvider";
import { formatAmount, isBitkeep, SHOW_MORPH_KEY } from "../utils";
import BigNumber from "bignumber.js";
import { useGlobalStore } from "@/stores/global";
import { EPageType, useTracker } from "../hooks/useTracker";
import { useBitKeepContext } from "@/components/BitKeepProvider";
const RevenuePanel = function() {
    let { className = "" } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { theme } = useGlobalStore();
    const { singleBGBIncome, totalBGBIncome, bgbPrice, totalStakeBGBAmount } = useStore();
    const { bitkeep, isReady } = useBitKeepContext();
    const t = useTranslations();
    const [open, setOpen] = useState(false);
    const { trackerExpose } = useTracker();
    const searchParams = useSearchParams();
    const { color } = useColor();
    const totalBGBAmountLocaleString = useMemo(()=>formatAmount(totalStakeBGBAmount), [
        totalStakeBGBAmount
    ]);
    const incomeList = useMemo(()=>{
        // TODO 科学计数法
        return [
            {
                text: t("pendingEarnings"),
                bgbIncome: formatAmount(singleBGBIncome, 6),
                uIncome: formatAmount(BigNumber(singleBGBIncome).times(bgbPrice).toString())
            },
            {
                text: t("totalEarnings"),
                bgbIncome: formatAmount(totalBGBIncome, 6),
                uIncome: formatAmount(BigNumber(totalBGBIncome).times(bgbPrice).toString())
            }
        ];
    }, [
        t,
        singleBGBIncome,
        totalBGBIncome,
        bgbPrice
    ]);
    const handleOpenQuestion = useCallback(()=>{
        setOpen(true);
        trackerExpose(EPageType.MORPH_EVENT_DESCRIPTION_PAGE);
    }, [
        trackerExpose
    ]);
    useEffect(()=>{
        if (isBitkeep) {
            if (isReady && bitkeep) {
                bitkeep.queryWebCache(SHOW_MORPH_KEY).then((param)=>{
                    let { success, data } = param;
                    if (!success || !data) {
                        handleOpenQuestion();
                    }
                });
                // 储存成功但会报超时，不能放在上面判断里一起用，会导致handleOpenQuestion无效
                setTimeout(()=>{
                    bitkeep.saveWebCache(SHOW_MORPH_KEY, "1").then((res)=>{
                        console.log("saveWebCache", res);
                    }).catch((res)=>{
                        console.log("saveWebCacheError", res);
                    });
                }, 300);
            }
        }
    }, [
        bitkeep,
        isReady,
        handleOpenQuestion
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "rounded-5 relative overflow-hidden ".concat(className, " ").concat(theme === "0" ? "".concat(styles.boxPanel, " bg-[var(--bg-0)]") : "", " py3 px5"),
        children: [
            theme === "1" ? /*#__PURE__*/ _jsx("div", {
                className: "bg-[var(--brightBlue)] opacity-12 absolute w-full h-full pointer-events-none left-0 top-0"
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-20px flex",
                        children: incomeList.map((item, index)=>{
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "w-50%",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text-13px text-[var(--text-7)] opacity-60 mb-4px",
                                        children: item.text
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "font-500 text-[var(--text-7)] text-15px mb-2px flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "font-600 text-[var(--text-7)] text-17px leading-21px",
                                                children: item.bgbIncome
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "font-500 text-[var(--text-3)] text-12px leading-14px ml-6px",
                                                children: "BGB"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-14px text-[var(--text-7)] opacity-60",
                                        children: [
                                            "$",
                                            item.uIncome
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb2 flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-[var(--text-7)] opacity-60 text-13px",
                                children: "Morph Point"
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: QuestionSvg.src,
                                alt: "question",
                                className: "w-13px h-13px ml1",
                                onClick: handleOpenQuestion
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-[var(--text-7)] font-500 text-14px ml3",
                                children: t("toBeIssued")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text-13px text-[var(--text-7)] opacity-60",
                                        children: t("totalStakedAmount")
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-[var(--text-7)] font-500 text-14px ml-12px",
                                        children: totalBGBAmountLocaleString
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-[var(--text-3)] font-500 text-12px ml1",
                                        children: "BGB"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Link, {
                                href: {
                                    pathname: "bgbStaking/my",
                                    query: searchParams.toString()
                                },
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-[var(--text-7)] text-13px",
                                        children: t("particular")
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        className: "h-[14px] rotate-y-180deg",
                                        src: color.arrow,
                                        alt: "go"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DrawerMorph, {
                open: open,
                onClose: ()=>setOpen(false)
            })
        ]
    });
};
export { RevenuePanel };
